<span class="material-symbols-outlined">
  <ng-content></ng-content>
</span>
